import React from "react";
import { FileText, Zap } from "lucide-react";
import TabPageLayout from "modules/swiftboard/components/TabPageLayout";
import useUrlTab from "modules/swiftboard/components/useUrlTab";
import Trigger from "./trigger/Trigger";
import Template from "./template/Template";

// Reusable building blocks of reminders (tbl_rem_trigger, tbl_rem_template): what to detect and what to say.
// `slug` is the ?tab= value: keep it stable even if the label changes.
const REMINDER_LIBRARY_TABS = [
  { id: 1, slug: "trigger", label: "Trigger", Icon: Zap, Page: Trigger },
  { id: 2, slug: "template", label: "Template", Icon: FileText, Page: Template },
];

const ReminderLibrary = () => {
  const [activeTab, setActiveTab] = useUrlTab(REMINDER_LIBRARY_TABS.map((tab) => tab.slug));
  const tabs = REMINDER_LIBRARY_TABS.map(({ id, label, Icon }) => ({ id, label, icon: <Icon size={18} /> }));
  const { slug, Page } = REMINDER_LIBRARY_TABS[activeTab];

  return (
    <TabPageLayout tabs={tabs} activeTab={activeTab} onTabChange={(index) => setActiveTab(index)}>
      <Page key={slug} />
    </TabPageLayout>
  );
};

export default ReminderLibrary;
